export const Z_INDEX = {
  BACKGROUND: 10,
  CONTENT: 20,
  OVERLAY: 30,
  NAV: 100,
  MODAL_BACKGROUND: 110,
  MODAL: 120,
}
